import { useEffect } from 'react';

import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { useRouter } from 'react-resource-router-next';

import { type Config } from '@atlaskit/react-ufo/config';
import { init } from '@atlaskit/react-ufo/interaction-metrics-init';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import traceUFOTransition from '@atlaskit/react-ufo/trace-transition';
import { getIdentityEnv } from '@atlassian/atlassian-studio-env-utils';
import { type StudioRoute } from '@atlassian/atlassian-studio-routing';

export const initReactUFO = (analyticsClient: AnalyticsWebClient) => {
	const config: Config = {
		vc: {
			enabled: true,
			heatmapSize: 200,
			oldDomUpdates: false,
			devToolsEnabled: true,

			// All DOM attributes currently set to false until UGC audit is completed
			// https://product-fabric.atlassian.net/browse/TC-11170
			selectorConfig: {
				id: false,
				role: false,
				className: false,
				testId: false,
			},
		},

		product: 'atlassianStudio',
		region: getIdentityEnv(),
		kind: {
			page_load: 1,
			transition: 1,
			press: 1,
			typing: 0,
			legacy: 0,
			hover: 0,
		},
		namePrefix: 'ufo-',
		segmentPrefix: 'ufo-',
	};

	init(Promise.resolve(analyticsClient), config);
};

type UfoRoutesNameMapper = { [key: string]: string };

let isInitialPageLoad = true;
export const useReactUFORouteWatcher = (routesToUfoNameMap?: UfoRoutesNameMapper) => {
	const [{ route, match }] = useRouter();
	const ufoName = (route as StudioRoute).ufoName || routesToUfoNameMap?.[route.path];

	useEffect(() => {
		if (ufoName) {
			if (isInitialPageLoad) {
				traceUFOPageLoad(ufoName);
				isInitialPageLoad = false;
			} else {
				traceUFOTransition(ufoName);
			}
		}
	}, [ufoName, match.url]);
};
